import $ from 'jquery';
import delay from '../delay';
import { roundCssTransformMatrix } from 'javascripts/bootstrap_utils';
import { setupURLParamTogglers } from 'javascripts/util/url_param_toggler';

let logIntoAhaWindow = null;
window.afterPopupLogin = function () {
  if (window.waitingForOpenerLogin) {
    window.waitingForOpenerLogin = false;
    $('.popover.active').trigger('portalUserReady').removeClass('active');
    setTimeout(() => window.location.reload(), 150); // Allow the vote or subscription action to complete before triggering the reload.
  }
};

$.fn.rebind = function (eventName, ...args) {
  this.off(eventName);
  return this.on(eventName, ...args);
};

// Make menu collapsed by default in mobile view
const hideRollup = function () {
  if ($(window).width() <= 670) {
    $('#sidebar-rollup.in').removeClass('in');
    $('.btn-navbar').addClass('collapsed');
  }
};

$(document).on('page:change', function () {
  hideRollup();
  setupURLParamTogglers();
});

$(function () {
  hideRollup();

  $(document).on('click', '.btn-navbar', function (event) {
    const $elem = $(this);
    $elem.toggleClass('is-shown');
    $elem.next('#sidebar-rollup').toggleClass('in');
  });

  // Enable attachment uploads.
  iripo.in(
    '.attachment-button, .attachment-link',
    node => {
      $(node).fileUploader({
        url: `/idea_portals/${$('meta[name=portal-token]').attr('content')}${$(
          node
        ).data('upload-url')}`,
        dropzoneScope: $(node).data('drop-zone-scope'),
        acceptFiles: $(node).data('supported-file-types'),
      });
    },
    true // Process the callback immediately after instantiation
  );

  // Category hints
  $(document).popover({
    selector: 'i.fa-circle-question',
    trigger: 'hover focus',
    delay,
  });

  // Poll counts
  $(document).popover({
    selector: '.idea-portal-section__grid i.fa-user-check',
    trigger: 'hover focus',
    delay,
  });

  $(document).on('click', '.log-into-aha', function (event) {
    window.waitingForOpenerLogin = true;
    if (logIntoAhaWindow) {
      logIntoAhaWindow.focus();
    } else {
      const url = $(this).attr('data-login-url');
      const width = 950;
      const height = 600;
      const left = screen.width / 2 - width / 2;
      const top = screen.height / 2 - height / 2;
      const windowFeatures = `location=0,status=0,width=${width},height=${height},top=${top},left=${left}`;
      logIntoAhaWindow = window.open(url, 'Login in with Aha!', windowFeatures);
    }
  });

  try {
    if (window.opener) {
      window.opener.afterPopupLogin();
      window.close();
    }
  } catch (error) {}
  // Nothing

  iripo.in('.modal', function (node) {
    // Enable modal dragging
    if ($(node).hasClass('undraggable')) {
      return;
    }

    $(node).draggable({
      containment: '#modal-drag-limit',
      handle: '.modal-header,aha-modal-header',
      scroll: false,
      cancel: 'input,textarea,button,select,option,.btn',
      // When you start dragging
      start(event, ui) {
        // Up the z index (hack to overcome bug with bootstrap modal interacting with jquery drag ui).
        // Rather than try to guess what the proper zIndex is, instead look at all the *visible* .modal-backdrop
        // elements, find out which one has the highest zIndex (this is the top-most backdrop),
        // and then make our modal window have a zIndex that is 1 number higher.
        const overlayZIndex = Array.from(
          document.querySelectorAll('.modal-backdrop')
        ).reduce(function (acc, item) {
          const styles = getComputedStyle(item);
          if (styles.display !== 'none' && styles.visibility !== 'hidden') {
            const zIndex = parseInt(styles.zIndex, 10);
            if (acc < zIndex) {
              acc = zIndex;
            }
          }

          return acc;
        }, 0);

        if (event) {
          $(event.target)
            .css({
              'z-index': overlayZIndex + 1,
              transition: 'all 0s ease 0s',
            })
            .attr('data-dragged', true);
        }
      },
      drag(event, ui) {
        if (this.classList.contains('modal-flex')) {
          event.target.dataset.currentX = event.screenX;
          if (this.classList.contains('modal-flex--vertical-center')) {
            event.target.dataset.currentY = event.screenY;
          }
        }
      },
      stop(event, ui) {
        if (event) {
          $(event.target).css('transition', '');
        }

        // If it is a modal flex, and the outer edge of the modal is dropped more than 100px from either the left or right
        // side, then move the modal accordingly so it is still visible on the page.
        if (this.classList.contains('modal-flex')) {
          const rect = event.target.getBoundingClientRect();
          const lowerBoundWidth = 100;
          const upperBoundWidth = document.body.offsetWidth - lowerBoundWidth;
          if (rect.left > upperBoundWidth) {
            event.target.dataset.startX = 0;
            event.target.dataset.currentX =
              (document.body.offsetWidth - rect.width) / 2 +
              rect.width -
              lowerBoundWidth;
          } else if (rect.right < lowerBoundWidth) {
            event.target.dataset.startX = 0;
            event.target.dataset.currentX = -(
              (document.body.offsetWidth - rect.width) / 2 +
              rect.width -
              lowerBoundWidth
            );
          }

          if (this.classList.contains('modal-flex--vertical-center')) {
            const lowerBoundHeight = 30;
            const upperBoundHeight = document.body.offsetHeight;
            if (rect.top > upperBoundHeight - 30) {
              event.target.dataset.startY = 0;
              event.target.dataset.currentY =
                (document.body.offsetHeight - rect.height) / 2 +
                rect.height -
                lowerBoundHeight; // document.body.offsetHeight - 100
            } else if (rect.top < 0) {
              event.target.dataset.startY = 0;
              event.target.dataset.currentY =
                -(document.body.offsetHeight - rect.height) / 2;
            }
          }
        }

        roundCssTransformMatrix(event.target);
      },
    });
  });
});

// For a <select data-show-color> tag, when an option is selected, set the appropriate color/background-color of the <select>.
iripo.in('select[data-show-color]', function (node) {
  if (!node.multiple) {
    updateSelectColors(node);
    node.addEventListener('change', function (event) {
      updateSelectColors(event.target);
    });
  }
});

// We set these as CSS variables rather than directly as style properties so that:
// 1. We can easily override these colors in the CSS if necessary.
// 2. If we happen to pass an invalid color, the browser will ignore it and use the default color.
//    This is better than breaking the UI by making the text illegible.
function updateSelectColors(node) {
  const selectedOptions = node.selectedOptions;
  if (selectedOptions.length > 0) {
    const opt = selectedOptions[0];

    // Set color of the select.
    if (opt.dataset.selectedColor) {
      node.style.setProperty('--selected-color', opt.dataset.selectedColor);
    }

    // Set background color of the select.
    if (opt.dataset.selectedBackgroundColor) {
      node.style.setProperty(
        '--selected-background-color',
        opt.dataset.selectedBackgroundColor
      );
    }
  } else {
    node.style.removeProperty('--selected-color');
    node.style.removeProperty('--selected-background-color');
  }
}
